window._ = require('lodash')
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
import filters from './filters' //es-lint-disable-line
import laravel from './Mixins/laravel'
import inertiaMixins from './Mixins/inertia'
import VuetifyHelpers from '@/Mixins/vuetify-helpers'

import Vue from 'vue'
import vuetify from './vuetify'
import { createInertiaApp, Link } from '@inertiajs/inertia-vue'
import Logo from './Shared/Logo'
import VueApexCharts from 'vue-apexcharts'

require('../sass/app.scss')

// https://inertiajs.com/routing
Vue.mixin({ methods: { route: window.route } })
Vue.prototype.$route = (...args) => route(...args).url()

Vue.mixin(laravel)
Vue.mixin(inertiaMixins)
Vue.mixin(VuetifyHelpers)

Vue.component('Apexchart', VueApexCharts)

createInertiaApp({
	resolve: name => require(`./Pages/${name}`),
	setup ({ el, App, props, plugin }) {
		Vue.use(plugin)
		Vue.component('Link', Link)
		Vue.component('Logo', Logo)

		new Vue({
			vuetify,
			render: h => h(App, props)
		}).$mount(el)
	}
}).then()
